<div class="min-h-screen bg-slate-50 px-4 py-8 sm:px-6 lg:px-8">
  <div class="mx-auto flex min-h-[calc(100vh-4rem)] w-full max-w-5xl items-center justify-center">
    <mat-card class="w-full overflow-hidden rounded-3xl border border-gray-300 bg-white">
      <mat-card-header class="border-b border-gray-300 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-700 px-6 py-8 text-white sm:px-8">
        <div class="space-y-2">
          <mat-card-title class="text-3xl font-bold tracking-tight sm:text-4xl">
            Try Publio Demo
          </mat-card-title>

          <mat-card-subtitle class="max-w-2xl text-sm leading-6 text-slate-200 sm:text-base">
            Fill out the form below to create a demo account and explore Publio's features.
          </mat-card-subtitle>
        </div>
      </mat-card-header>

      <mat-card-content class="px-6 py-8 sm:px-8">
        <form #demoForm="ngForm" (ngSubmit)="onSubmit(demoForm)" class="space-y-8">
          <!-- Company Information -->
          <section class="rounded-2xl p-5 sm:p-6">
            <div class="mb-5">
              <h3 class="text-lg font-semibold tracking-tight text-slate-900">
                Company Information
              </h3>
              <p class="mt-1 text-sm text-slate-500">
                Tell us a few details about your company.
              </p>
            </div>

            <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
              <mat-form-field class="w-full md:col-span-2">
                <mat-label>Company Name </mat-label>
                <input
                  matInput
                  [(ngModel)]="company_name"
                  name="company_name"
                  required
                  maxlength="255"
                >
              </mat-form-field>

              <mat-form-field class="w-full">
                <mat-label>City</mat-label>
                <input
                  matInput
                  [(ngModel)]="company_city"
                  name="company_city"
                  maxlength="100"
                >
              </mat-form-field>

              <mat-form-field class="w-full">
                <mat-label>Address</mat-label>
                <input
                  matInput
                  [(ngModel)]="company_address"
                  name="company_address"
                  maxlength="255"
                >
              </mat-form-field>
            </div>
          </section>

          <!-- User Information -->
          <section class="rounded-2xl p-5 sm:p-6">
            <div class="mb-5">
              <h3 class="text-lg font-semibold tracking-tight text-slate-900">
                User Information
              </h3>
              <p class="mt-1 text-sm text-slate-500">
                Add the primary contact for the demo account.
              </p>
            </div>

            <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
              <mat-form-field class="w-full">
                <mat-label>First Name </mat-label>
                <input
                  matInput
                  [(ngModel)]="user_first_name"
                  name="user_first_name"
                  required
                  maxlength="100"
                >
              </mat-form-field>

              <mat-form-field class="w-full">
                <mat-label>Last Name </mat-label>
                <input
                  matInput
                  [(ngModel)]="user_last_name"
                  name="user_last_name"
                  required
                  maxlength="100"
                >
              </mat-form-field>

              <mat-form-field class="w-full">
                <mat-label>Email </mat-label>
                <input
                  matInput
                  type="email"
                  [(ngModel)]="user_email"
                  name="user_email"
                  required
                  maxlength="255"
                >
              </mat-form-field>

              <mat-form-field class="w-full">
                <mat-label>Phone</mat-label>
                <input
                  matInput
                  [(ngModel)]="user_phone"
                  name="user_phone"
                  maxlength="20"
                >
              </mat-form-field>
            </div>
          </section>

          <!-- Site Information -->
          <section class="rounded-2xl p-5 sm:p-6">
            <div class="mb-5">
              <h3 class="text-lg font-semibold tracking-tight text-slate-900">
                Site Information
              </h3>
              <p class="mt-1 text-sm text-slate-500">
                Provide the website URL connected to the demo.
              </p>
            </div>

            <div class="grid grid-cols-1 gap-4">
              <mat-form-field class="w-full">
                <mat-label>Site URL </mat-label>
                <input
                  matInput
                  [(ngModel)]="site_url"
                  name="site_url"
                  required
                  maxlength="255"
                  placeholder="https://example.com"
                >
              </mat-form-field>
            </div>
          </section>

          <!-- Social Media -->
          <section class="rounded-2xl p-5 sm:p-6">
            <div class="mb-5">
              <h3 class="text-lg font-semibold tracking-tight text-slate-900">
                Social Media
              </h3>
              <p class="mt-1 text-sm text-slate-500">
                Connect the main social media account for this demo.
              </p>
            </div>

            <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
              <mat-form-field class="w-full">
                <mat-label>Platform </mat-label>
                <mat-select [(ngModel)]="platform" name="platform" required>
                  <mat-option value="Facebook">Facebook</mat-option>
                  <mat-option value="Instagram">Instagram</mat-option>
                  <mat-option value="TikTok">TikTok</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="w-full">
                <mat-label>Social Media ID </mat-label>
                <input
                  matInput
                  [(ngModel)]="social_media_id"
                  name="social_media_id"
                  required
                  maxlength="255"
                >
              </mat-form-field>
            </div>
          </section>

          <!-- RSS Feeds -->
          <section class="rounded-2xl p-5 sm:p-6">
            <div class="mb-5">
              <h3 class="text-lg font-semibold tracking-tight text-slate-900">
                RSS Feeds
                <span class="font-normal text-slate-500">( At least one (1) )</span>
              </h3>
              <p class="mt-1 text-sm text-slate-500">
                Add up to 3 RSS feeds for your demo.
              </p>
            </div>

            <div class="space-y-4">
              <div
                *ngFor="let feed of rss_feeds; let i = index; trackBy: trackByIndex"
                class="grid grid-cols-1 gap-4 rounded-xl p-4 md:grid-cols-2"
              >
                <mat-form-field class="w-full">
                  <mat-label>Feed Name</mat-label>
                  <input
                    matInput
                    [(ngModel)]="feed.feed"
                    [name]="'feed_name_' + i"
                    [required]="i === 0"
                    maxlength="255"
                  >
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label>Feed URL</mat-label>
                  <input
                    matInput
                    [(ngModel)]="feed.url"
                    [name]="'feed_url_' + i"
                    [required]="i === 0"
                    maxlength="500"
                    placeholder="https://example.com/rss"
                  >
                </mat-form-field>
              </div>
            </div>
          </section>

          <!-- Messages -->
          <div
            *ngIf="message"
            [ngClass]="{
              'border-emerald-300 bg-emerald-50 text-emerald-800': success,
              'border-red-300 bg-red-50 text-red-800': !success
            }"
            class="rounded-2xl border px-5 py-4 text-sm font-medium"
          >
            {{ message }}
          </div>

          <!-- Submit Button -->
          <div class="flex flex-col-reverse gap-3 border-t border-gray-300 pt-6 sm:flex-row sm:items-center sm:justify-end">
            <button
              mat-raised-button
              color="primary"
              type="submit"
              [disabled]="demoForm.invalid || loading"
              class="w-full rounded-xl px-6 py-3 font-semibold transition-all duration-200 sm:w-auto"
            >
              <span *ngIf="!loading">Create Demo Account</span>
              <mat-spinner *ngIf="loading" diameter="20" class="inline-block"></mat-spinner>
            </button>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>